<template>
  <div class="myInvest">
    <van-nav-bar
      :title="$t('m.tz_span0')"
      fixed
      placeholder
      :border="false"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="content">
      <div class="interest_card">
        <div class="interest_summary">
          <span class="summary_label">{{ $t("m.cw_span3") }}</span>
          <span class="summary_value">{{ daishou }}</span>
          <span class="summary_unit">USD</span>
        </div>
      </div>

      <div class="detail_card">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('m.gengduo')"
          @load="onLoad"
        >
          <div
            class="card_item"
            v-for="(item, index) in list"
            :key="index"
          >
            <!-- <router-link :to="{path:'contract/', query:{id:item.id}}"> -->
            <div class="item_title" style="color: #333">{{ item.title }}</div>
            <div class="purchase_code">
              <!-- <span>申购代码：{{item.code}}</span> -->
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <div>
                <div
                  class="purchase_code"
                  style="display: flex; align-items: center"
                >
                  <img
                    src="../../assets/images/new/bianhao.png"
                    style="width: 20px; height: 20px; margin-right: 12px"
                    alt=""
                  />
                  <span>{{ $t("m.tz_span1") }}:{{ item.id }}</span>
                </div>
                <van-count-down :time="item.end_time">
                  <template #default="timeData">
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        padding: 10px 0;
                      "
                    >
                      <img
                        src="../../assets/images/daojishi.png"
                        style="width: 20px; height: 20px; margin-right: 12px"
                        alt=""
                      />
                      <span>到期时间：</span>
                      {{ item.end }}
                      <!--                      <span class="block">{{ timeData.days }}</span>-->
                      <!--                      <span class="colon">d</span>-->
                      <!--                      <span class="block">{{ timeData.hours }}</span>-->
                      <!--                      <span class="colon">h</span>-->
                      <!--                      <span class="block">{{ timeData.minutes }}</span>-->
                      <!--                      <span class="colon">m</span>-->
                      <!--                      <span class="block">{{ timeData.seconds }}</span>-->
                      <!--                      <span class="colon">s</span>-->
                    </div>
                  </template>
                </van-count-down>
                <div
                  class="get_money"
                  style="display: flex; align-items: center"
                >
                  <img
                    src="../../assets/images/new/honghao.png"
                    style="width: 20px; height: 20px; margin-right: 12px"
                    alt=""
                  />
                  <div>
                    {{ $t("m.tz_span3") }}
                    <span style="color: var(--bg-color)">{{
                      item.receive_profit
                    }}</span>
                    USD
                  </div>
                </div>
              </div>
              <img
                src="../../assets/images/new/hetong.png"
                style="width: 40px; height: 40px; margin-right: 12px"
                alt=""
              />
            </div>
            <div class="get_money_detail">
              <div>
                <span>{{ $t("m.tz_span4") }}</span>
                <span style="color: var(--bg-color)">{{ item.money }}</span>
              </div>
              <div>
                <span>{{ $t("m.jy_span8") }}</span>
                <span style="color: var(--bg-color)">{{ item.rate }}</span>
              </div>
              <div>
                <span>{{ $t("m.tz_span5") }}</span>
                <span style="color: var(--bg-color)">{{
                  item.zongshouyi
                }}</span>
              </div>
            </div>
            <div class="insurance-panel">
              <div class="insurance-heading">
                <span>本息保障权益</span>
                <b>{{ item.insurance_status }}</b>
              </div>
              <p><span>合同编号</span>{{ item.insurance_contract_no }}</p>
              <p><span>合同义务人</span>{{ item.insurance_company }}</p>
              <p><span>保障期限</span>{{ item.coverage_start }} 至 {{ item.coverage_end }}</p>
              <p><span>返利方式</span>{{ item.repayment_method }}</p>
              <p v-if="Number(item.gift_fixed) > 0">
                <span>建仓红包</span>{{ item.gift_fixed }} USD · 已到账
              </p>
              <button @click.stop="contract(item.id)">查看本金及收益保障合同</button>
            </div>
            <!-- </router-link> -->
          </div>
        </van-list>
      </div>
    </div>
    <div style="height: 34px"></div>
  </div>
</template>

<script>
import request from "@utils/request";
// import $store from "../../store";
// import { VUE_APP_API_URL } from "@utils/index";
export default {
  name: "",
  data() {
    return {
      list: [],
      page: 0,
      loading: false,
      finished: false,
      refreshing: false,
      yishou: 0,
      daishou: 0,
      uyishou: 0,
      udaishou: 0
    };
  },
  mounted() {
    // this.$toast.loading({
    //   message: "数据加载中...",
    //   forbidClick: true
    // });
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    async onLoad() {
      this.page = this.page + 1;
      let _this = this;

      request
        .get("/fund/log/list", { page: _this.page }, { login: true })
        .then(res => {
          console.log("日利宝列表数据");
          console.log(res);
          this.yishou = res.data.data.tongji.yishou;
          this.daishou = res.data.data.tongji.daishou;
          this.uyishou = res.data.data.tongji.uyishou;
          this.udaishou = res.data.data.tongji.udaishou;
          if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
          }
          for (var i = 0; i < res.data.data.list.length; i++) {
            console.log(res.data.data.list[i]["end_time"]);
            console.log(new Date().getTime() / 1000);
            this.list.push({
              id: res.data.data.list[i]["id"],
              title: res.data.data.list[i]["title"],
              code: res.data.data.list[i]["cday"],
              income: res.data.data.list[i]["income"],
              money: res.data.data.list[i]["money"],
              rate: (
                Number(res.data.data.list[i]["rate"]) +
                Number(res.data.data.list[i]["viprate"] || 0)
              ).toFixed(2),
              clock: res.data.data.list[i]["clock"],
              zongshouyi: Number(res.data.data.list[i]["zongshouyi"]).toFixed(
                2
              ),
              end: res.data.data.list[i]["end"],
              end_time:
                (res.data.data.list[i]["end_time"] -
                  new Date().getTime() / 1000) *
                1000,
              receive_profit: res.data.data.list[i]["profit"],
              insurance_contract_no:
                res.data.data.list[i]["insurance_contract_no"],
              insurance_company: res.data.data.list[i]["insurance_company"],
              insurance_status: res.data.data.list[i]["insurance_status"],
              coverage_start: res.data.data.list[i]["coverage_start"],
              coverage_end: res.data.data.list[i]["coverage_end"],
              repayment_method: res.data.data.list[i]["repayment_method"],
              gift_fixed: Number(
                res.data.data.list[i]["gift_fixed"] || 0
              ).toFixed(2)
            });
          }
          this.loading = false;

          if (res.data.data.list.length < 10) {
            this.finished = true;
          }
        })
        .catch(err => {
          console.log(err);

          this.finished = true;
          this.loading = false;
        });
    },
    contract(id) {
      // window.location.href = VUE_APP_API_URL+"/fund/hetong/index?id="+id+"&token="+$store.state.app.token

      this.$router.push({
        path: "/Contract",
        query: {
          id: id
        }
      });
    }
  },
  components: {}
};
</script>

<style scoped lang="less">
.colon {
  display: inline-block;
  margin: 0 4px;
}
.block {
  display: inline-block;
  width: 22px;
  color: var(--bg-color);
  font-size: 12px;
  text-align: center;
}
.myInvest /deep/ .van-nav-bar {
  box-shadow: 0 0 0 #ccc;
  background-color: rgba(0, 0, 0, 0);
}
.myInvest /deep/ .van-nav-bar__title {
  color: #fff;
}
.myInvest /deep/ .van-icon {
  color: #fff;
}
.myInvest {
  height: 100vh;
  background-color: #f6f6f6;
  .content {
    margin-top: -46px;
    padding: 15px 0;
    background-image: url(../../assets/images/bg/8.png);
    background-repeat: no-repeat;
    background-size: 100% 175px;
    .interest_card {
      padding: 20px 12px;

      border-radius: 5px;
      margin: 60px 15px 0;
      background-color: #fff;
      box-shadow: 0px 0px 6px #eaeaea;
      .interest_summary {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        min-height: 34px;
        white-space: nowrap;
      }
      .summary_label {
        color: #666;
        font-size: 14px;
      }
      .summary_value {
        color: var(--bg-color);
        font-size: 24px;
        font-weight: bold;
        line-height: 1;
      }
      .summary_unit {
        color: var(--bg-color);
        font-size: 14px;
        font-weight: bold;
      }
    }
    .detail_card {
      // background: #dfdfdf;
      margin-top: 10px;
      font-size: 14px;
      .card_item {
        padding: 15px 20px 10px;
        margin-bottom: 10px;
        border-radius: 5px;
        background-color: #fff;
        .item_title {
          padding-bottom: 15px;
          border-bottom: 1px solid #f2f2f2;
        }
        .purchase_code,
        .order_num,
        .get_money {
          line-height: 30px;
          color: #333;
        }
        .get_money_detail {
          display: flex;
          justify-content: space-between;
          color: #333;
          div {
            display: flex;
            flex-direction: column;
            span:nth-child(1) {
              padding: 10px 0;
              font-size: 12px;
              color: #666;
            }
          }
        }
        .insurance-panel {
          margin-top: 14px;
          padding: 13px;
          color: #355f56;
          background: #edf5fb;
          border: 1px solid #d8e8f4;
          border-radius: 10px;
          .insurance-heading {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 9px;
            font-weight: 700;
            b {
              color: #168266;
              font-size: 11px;
            }
          }
          p {
            display: flex;
            margin: 6px 0;
            font-size: 11px;
            span {
              width: 66px;
              color: #789087;
            }
          }
          button {
            width: 100%;
            margin-top: 8px;
            padding: 9px;
            color: #fff;
            font-size: 12px;
            border: 0;
            background: #1769b0;
            border-radius: 18px;
          }
        }
      }
    }
    .loading_finish {
      text-align: center;
      margin-top: 10px;
      font-size: 12px;
      color: #666;
    }
  }
}
</style>

